<template>
  <div>
    <b-spinner
      v-if="this.loading == true"
      style="width: 3rem; height: 3rem;"
      type="grow"
      label="Loading..."
      variant="info"
    ></b-spinner>
    <div v-if="this.loading == false">
      <b-card
        no-body
        border-variant="dark"
        align="center"
        header-bg-variant="secondary"
        v-if="this.detailToShow == 'Subgroup'"
      >
        <template #header
          ><h4>{{ headerText }}</h4>
        </template>
        <b-card header="Group Levels">
          <b-row
            ><b-col class="text-left"><b>Level 1:</b> </b-col>
            <b-col
              class="text-left"
              v-if="this.dataToDisplay[0].Level1 != null"
              >{{ this.dataToDisplay[0].Level1 }}</b-col
            >
            <b-col class="text-left" v-if="this.dataToDisplay[0].Level1 == null"
              >No Level 1 Filter</b-col
            >
          </b-row>
          <b-row
            ><b-col class="text-left"><b>Level 2:</b> </b-col>
            <b-col
              class="text-left"
              v-if="this.dataToDisplay[0].Level2 != null"
              >{{ this.dataToDisplay[0].Level2 }}</b-col
            >
            <b-col class="text-left" v-if="this.dataToDisplay[0].Level2 == null"
              >No Level 2 Filter</b-col
            >
          </b-row>
          <b-row
            ><b-col class="text-left"><b>Level 3:</b> </b-col>
            <b-col
              class="text-left"
              v-if="this.dataToDisplay[0].Level3 != null"
              >{{ this.dataToDisplay[0].Level3 }}</b-col
            >
            <b-col class="text-left" v-if="this.dataToDisplay[0].Level3 == null"
              >No Level 3 Filter</b-col
            >
          </b-row>
        </b-card>
        <br />
        <b-card header="Device Details">
          <b-row>
            <b-col class="text-center"
              ><h5>
                There are
                {{
                  this.dataToDisplay[0].TrendingUpCount +
                    this.dataToDisplay[0].StableCount +
                    this.dataToDisplay[0].TrendingDownCount
                }}
                Devices Listed in This Location Group
              </h5></b-col
            >
          </b-row>
          <br />
          <b-row
            ><b-col class="text-left"><b>Trending Up:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].TrendingUpCount
            }}</b-col></b-row
          >
          <b-row
            ><b-col class="text-left"><b>Stable:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].StableCount
            }}</b-col></b-row
          >
          <b-row
            ><b-col class="text-left"><b>Trending Down:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].TrendingDownCount
            }}</b-col></b-row
          >
        </b-card>
        <br />
        <!-- <b-card header="Group Testing Counts">
          <b-row>
            <b-col class="text-left"><b>New Water Tests:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].NewTests
            }}</b-col>
          </b-row>
          <b-row>
            <b-col class="text-left"><b>Tests In Progress:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].ProgressTests
            }}</b-col>
          </b-row>
          <b-row>
            <b-col class="text-left"><b>Ready For Review:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].ReviewTests
            }}</b-col>
          </b-row>
          <b-row>
            <b-col class="text-left"><b>Scheduled:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].ScheduledTests
            }}</b-col>
          </b-row>
          <b-row>
            <b-col class="text-left"><b>Completed:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].CompletedTests
            }}</b-col>
          </b-row>
        </b-card> -->
        <!-- <br />
        <b-card header="Group Risk Assessment Counts">
          <b-row>
            <b-col class="text-left"><b>Risk Assessments Due:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].RiskAssessmentDue
            }}</b-col>
          </b-row>
          <b-row>
            <b-col class="text-left"><b>Valid Assessments:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].RiskAssessmentValid
            }}</b-col>
          </b-row>
          <b-row>
            <b-col class="text-left"><b>Expired Assessments:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].RiskAssessmentExpired
            }}</b-col>
          </b-row>
          <b-row>
            <b-col class="text-left"><b>Completed:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].RiskAssessmentCompleted
            }}</b-col>
          </b-row>
        </b-card>
        <br /> -->
        <!-- <b-card header="Group Action Counts">
          <b-row>
            <b-col class="text-left"><b>New Actions:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].ActionsNew
            }}</b-col>
          </b-row>
          <b-row>
            <b-col class="text-left"><b>Overdue Action: </b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].ActionsOverdue
            }}</b-col>
          </b-row>
          <b-row>
            <b-col class="text-left"><b>Upcoming Actions due:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].ActionsDue
            }}</b-col>
          </b-row>
          <b-row>
            <b-col class="text-left"><b>Completed:</b> </b-col
            ><b-col class="text-left">{{
              this.dataToDisplay[0].ActionsCompleted
            }}</b-col>
          </b-row>
        </b-card>
        <br /> -->
        <!-- <b-card header="Group Accessory Counts">
          <b-row>
            <b-col class="text-left"><b>Shower Accessories:</b> </b-col
            ><b-col class="text-left"
              ><b>Due:</b> {{ this.dataToDisplay[0].ShowerDue }}</b-col
            >
          </b-row>
          <b-row>
            <b-col class="text-left"></b-col
            ><b-col class="text-left"
              ><b>Overdue:</b> {{ this.dataToDisplay[0].ShowerOverDue }}</b-col
            >
          </b-row>
          <br />
          <b-row>
            <b-col class="text-left"><b>Filter Changes:</b> </b-col
            ><b-col class="text-left"
              ><b>Due:</b> {{ this.dataToDisplay[0].FiltersDue }}</b-col
            >
          </b-row>
          <b-row>
            <b-col class="text-left"></b-col
            ><b-col class="text-left"
              ><b>Overdue:</b> {{ this.dataToDisplay[0].FiltersOverDue }}</b-col
            >
          </b-row>
        </b-card> -->
        <!-- <br /> -->
      </b-card>
      <div v-if="this.detailToShow == 'C-1'">
        <b-card
          no-body
          border-variant="dark"
          align="center"
          header-bg-variant="secondary"
        >
          <template #header
            ><h4>{{ headerText }}</h4>
          </template>
          <br />
          <!-- <p>Clarence card should show (both C-1 and O-1) -</p> -->
          <!-- {{ this.dataToDisplay }} -->
          <b-card-body>
            <b-card-sub-title class="mb-2"
              >Location: {{ this.dataToDisplay[0].Location }}</b-card-sub-title
            >

            <b-card-sub-title class="mb-2">
              Installation Date: {{ this.dataToDisplay[0].InstallDate }} at
              {{ this.dataToDisplay[0].InstallTime }}
            </b-card-sub-title>

            <b-card header="Position Details">
              <b-row>
                <b-col class="text-left"><b>Room/Area:</b> </b-col>
                <b-col class="text-left">
                  {{ this.dataToDisplay[0].DeptFloor }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Position:</b> </b-col>
                <b-col class="text-left">
                  {{ this.dataToDisplay[0].LocationNote }}</b-col
                >
              </b-row>
              <!-- <b-row>
                <b-col class="text-left"><b>Feed:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Feed
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Position Note:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].LocationNote
                }}</b-col>
              </b-row> -->
              <br />
              <b-row>
                <b-col class="text-center"
                  ><h5>
                    Device Linked with
                    {{ this.dataToDisplay[0].SubGroupCount }} Location Group(s)
                  </h5></b-col
                >
              </b-row>
            </b-card>
            <br/>
             <br />
            <b-card header="Reading Details">
              <b-row>
                <b-col class="text-left"><b>Last Reading:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[0].LastTempReadingDate }} at
                  {{ this.dataToDisplay[0].LastTempReadingTime }}</b-col
                >
              </b-row>
            </b-card>
            <br />
             <b-card
              header="Probe 1"
              v-if="this.dataToDisplay[0].Probe1Show == 'TRUE'"
            >
              <b-row>
                <b-col class="text-left"><b>Position:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe1Position
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Feed:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe1Feed
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Tag:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe1Tag
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Temperatures:</b> </b-col>
                <b-col class="text-left"
                  ><b>Avg:</b>
                  {{ this.dataToDisplay[0].Probe1LastTempAvg }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Min:</b>
                  {{ this.dataToDisplay[0].Probe1LastTempMin }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Max:</b>
                  {{ this.dataToDisplay[0].Probe1LastTempMax }}&#8451;</b-col
                >
              </b-row>

              <b-row>
                <b-col class="text-left"><b>Last Flow:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[0].Probe1LastFlowDate }} at
                  {{ this.dataToDisplay[0].Probe1LastFlowTime }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Calibration:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe1CalibrationDate
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Calibration Expiry:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe1NextCalibrate
                }}</b-col>
              </b-row>
            </b-card>
            <br/>
             <b-card
              header="Probe 2"
              v-if="this.dataToDisplay[0].Probe2Show == 'TRUE'"
            >
              <b-row>
                <b-col class="text-left"><b>Position:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe2Position
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Feed:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe2Feed
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Tag:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe2Tag
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Temperatures:</b> </b-col>
                <b-col class="text-left"
                  ><b>Avg:</b>
                  {{ this.dataToDisplay[0].Probe2LastTempAvg }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Min:</b>
                  {{ this.dataToDisplay[0].Probe2LastTempMin }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Max:</b>
                  {{ this.dataToDisplay[0].Probe2LastTempMax }}&#8451;</b-col
                >
              </b-row>

              <b-row>
                <b-col class="text-left"><b>Last Flow:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[0].Probe2LastFlowDate }} at
                  {{ this.dataToDisplay[0].Probe2LastFlowTime }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Calibration:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe2CalibrationDate
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Calibration Expiry:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe2NextCalibrate
                }}</b-col>
              </b-row>
            </b-card>
            <!-- <b-card header="Position Details" v-if="this.dataToDisplay[0].Double=='TRUE'">
              <b-row>
                <b-col class="text-left"><b>Room/Area:</b> </b-col>
                <b-col class="text-left">
                  {{ this.dataToDisplay[0].DeptFloor }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Position:</b> </b-col>
                <b-col class="text-left">
                  {{ this.dataToDisplay[0].Position }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Position Note:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].LocationNote
                }}</b-col>
              </b-row>
              <br />
              <b-row>
                <b-col class="text-center"
                  ><h5>
                    Device Linked with
                    {{ this.dataToDisplay[0].SubGroupCount }} Location Group(s)
                  </h5></b-col
                >
              </b-row>
            </b-card> -->
            <br />
            <!-- <p>linked outlets</p> -->
            <!-- <b-card header="Reading Details" v-if="this.dataToDisplay[0].Double == 'FALSE'">
              <b-row>
                <b-col class="text-left"><b>Last Reading:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[0].LastTempReadingDate }} at
                  {{ this.dataToDisplay[0].LastTempReadingTime }}</b-col
                >
              </b-row>
              <b-row
                ><b-col><br /></b-col
              ></b-row>
              <b-row>
                <b-col class="text-left"><b>Last Temperatures:</b> </b-col>
                <b-col class="text-left"
                  ><b>Avg:</b>
                  {{ this.dataToDisplay[0].LastTempReadingAvg }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Min:</b>
                  {{ this.dataToDisplay[0].LastTempReadingMin }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Max:</b>
                  {{ this.dataToDisplay[0].LastTempReadingMax }}&#8451;</b-col
                >
              </b-row>
              <br />
              <b-row>
                <b-col class="text-left"> <b> Last Flow: </b> </b-col>
                <b-col class="text-left">
                  {{ this.dataToDisplay[0].LastFlowDate }} at
                  {{ this.dataToDisplay[0].LastFlowTime }}
                </b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Calibration:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[0].CalibrationDate }} at
                  {{ this.dataToDisplay[0].CalibrationTime }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Calibration Expiry:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].NextCalibrationDate
                }}</b-col>
              </b-row>
            </b-card> -->
            <!-- <b-card header="Reading Details" v-if="this.dataToDisplay[0].Double == 'TRUE'">
              <b-row>
                <b-col class="text-left"><b>Last Reading:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[0].LastTempReadingDate }} at
                  {{ this.dataToDisplay[0].LastTempReadingTime }}</b-col
                >
              </b-row>
            </b-card>
            <br />
            <div v-if="this.dataToDisplay[0].Double == 'TRUE'">
            <b-card header="Pipe A">
              <b-row>
                <b-col>{{ this.dataToDisplay[0].Feed }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Temperatures:</b> </b-col>
                <b-col class="text-left"
                  ><b>Avg:</b>
                  {{ this.dataToDisplay[0].LastTempReadingAvg }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Min:</b>
                  {{ this.dataToDisplay[0].LastTempReadingMin }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Max:</b>
                  {{ this.dataToDisplay[0].LastTempReadingMax }}&#8451;</b-col
                >
              </b-row>
              <br />
              <b-row>
                <b-col class="text-left"> <b> Last Flow: </b> </b-col>
                <b-col class="text-left">
                  {{ this.dataToDisplay[0].LastFlowDate }} at
                  {{ this.dataToDisplay[0].LastFlowTime }}
                </b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Calibration:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[0].CalibrationDate }} at
                  {{ this.dataToDisplay[0].CalibrationTime }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Calibration Expiry:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].NextCalibrationDate
                }}</b-col>
              </b-row>
              </b-card>
            <br>
            <b-card header="Pipe B">
              <b-row>
                <b-col>{{ this.dataToDisplay[1].Feed }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Temperatures:</b> </b-col>
                <b-col class="text-left"
                  ><b>Avg:</b>
                  {{ this.dataToDisplay[1].LastTempReadingAvg }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Min:</b>
                  {{ this.dataToDisplay[1].LastTempReadingMin }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Max:</b>
                  {{ this.dataToDisplay[1].LastTempReadingMax }}&#8451;</b-col
                >
              </b-row>
              <br />
              <b-row>
                <b-col class="text-left"> <b> Last Flow: </b> </b-col>
                <b-col class="text-left">
                  {{ this.dataToDisplay[1].LastFlowDate }} at
                  {{ this.dataToDisplay[1].LastFlowTime }}
                </b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Calibration:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[1].CalibrationDate }} at
                  {{ this.dataToDisplay[1].CalibrationTime }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Calibration Expiry:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[1].NextCalibrationDate
                }}</b-col>
              </b-row>
              </b-card>
            <br/> -->
            <!-- </div> -->
            
            <!-- <p>current trend direction</p> -->
            <b-card header="Service Details">
              <b-row>
                <b-col class="text-left"><b>Last Service: </b></b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].LastServiceCheckDate
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Next Service:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].NextServiceAction
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Next Service Due:</b> </b-col>
                <b-col
                  v-if="
                    this.dataToDisplay[0].NextServiceDate ==
                      'No Future Service Planned'
                  "
                  class="text-left"
                  >{{ this.dataToDisplay[0].NextServiceDate }}</b-col
                >
                <b-col
                  v-if="
                    this.dataToDisplay[0].NextServiceDate !=
                      'No Future Service Planned'
                  "
                  class="text-left"
                  >{{ this.dataToDisplay[0].NextServiceDate }} at
                  {{ this.dataToDisplay[0].NextServiceTime }}</b-col
                >
              </b-row>
              <b-row
                ><b-col><br /></b-col
              ></b-row>
            </b-card>
            <br />
            <b-card header="Linked Devices">
              <h5 v-if="this.dataToDisplay[0].LinkedAssets.length == 0">
                You don't currently have any endpoints associated with this
                device.
              </h5>
              <b-card-body>
                <b-row
                  v-for="(id, idx) in this.dataToDisplay[0].LinkedAssets"
                  :key="idx"
                >
                  <b-col class="text-left"><b>Type:</b> {{ id.Type }}</b-col>
                  <b-col class="text-left"><b>ID:</b> {{ id.ID }}</b-col>
                </b-row>
              </b-card-body>
            </b-card>
            <br />
          </b-card-body>
        </b-card>
      </div>

      <div v-if="this.detailToShow == 'O-1'">
        <b-card
          no-body
          border-variant="dark"
          align="center"
          header-bg-variant="secondary"
        >
          <template #header
            ><h4>{{ headerText }}</h4>
          </template>
          <br />
          <!-- <p>Clarence card should show (O-1) -</p> --> 
          <b-card-body>
            <b-card-sub-title class="mb-2"
              >Location: {{ this.dataToDisplay[0].Location }}</b-card-sub-title
            >

            <b-card-sub-title class="mb-2">
              Installation Date: {{ this.dataToDisplay[0].InstallDate }} at
              {{ this.dataToDisplay[0].InstallTime }}
            </b-card-sub-title>
            <b-card header="Position Details">
              <b-row>
                <b-col class="text-left"><b>Room/Area:</b> </b-col>
                <b-col class="text-left">
                  {{ this.dataToDisplay[0].DeptFloor }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Position Note:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].LocationNote
                }}</b-col>
              </b-row>
              <br />
              <b-row v-if="this.dataToDisplay[0].SubGroupCount != null">
                <b-col class="text-center"
                  ><h5>
                    Device Linked with
                    {{ this.dataToDisplay[0].SubGroupCount }} Location Group(s)
                  </h5></b-col
                >
              </b-row>
            </b-card>
            <br />
            <b-card header="Reading Details">
              <b-row>
                <b-col class="text-left"><b>Last Reading:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[0].LastTempReadingDate }} at
                  {{ this.dataToDisplay[0].LastTempReadingTime }}</b-col
                >
              </b-row>
            </b-card>
            <br />
            <b-card
              header="Probe 1"
              v-if="this.dataToDisplay[0].Probe1Show == 'TRUE'"
            >
              <b-row>
                <b-col class="text-left"><b>Position:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe1Position
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Tag:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe1Tag
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Temperatures:</b> </b-col>
                <b-col class="text-left"
                  ><b>Avg:</b>
                  {{ this.dataToDisplay[0].Probe1LastTempAvg }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Min:</b>
                  {{ this.dataToDisplay[0].Probe1LastTempMin }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Max:</b>
                  {{ this.dataToDisplay[0].Probe1LastTempMax }}&#8451;</b-col
                >
              </b-row>

              <b-row>
                <b-col class="text-left"><b>Last Flow:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[0].Probe1LastFlowDate }} at
                  {{ this.dataToDisplay[0].Probe1LastFlowTime }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Calibration:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe1CalibrationDate
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Calibration Expiry:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe1NextCalibrate
                }}</b-col>
              </b-row>
            </b-card>
            <b-card
              header="Probe 2"
              v-if="this.dataToDisplay[0].Probe2Show == 'TRUE'"
            >
              <b-row>
                <b-col class="text-left"><b>Position:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe2Position
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Tag:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe2Tag
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Temperatures:</b> </b-col>
                <b-col class="text-left"
                  ><b>Avg:</b>
                  {{ this.dataToDisplay[0].Probe2LastTempAvg }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Min:</b>
                  {{ this.dataToDisplay[0].Probe2LastTempMin }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Max:</b>
                  {{ this.dataToDisplay[0].Probe2LastTempMax }}&#8451;</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Flow:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[0].Probe2LastFlowDate }} at
                  {{ this.dataToDisplay[0].Probe2LastFlowTime }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Calibration:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe2CalibrationDate
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Calibration Expiry:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe2NextCalibrate
                }}</b-col>
              </b-row>
            </b-card>
            <b-card
              header="Probe 3"
              v-if="this.dataToDisplay[0].Probe3Show == 'TRUE'"
            >
              <b-row>
                <b-col class="text-left"><b>Position:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe3Position
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Tag:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe3Tag
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Temperatures:</b> </b-col>
                <b-col class="text-left"
                  ><b>Avg:</b>
                  {{ this.dataToDisplay[0].Probe3LastTempAvg }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Min:</b>
                  {{ this.dataToDisplay[0].Probe3LastTempMin }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Max:</b>
                  {{ this.dataToDisplay[0].Probe3LastTempMax }}&#8451;</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Flow:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[0].Probe3LastFlowDate }} at
                  {{ this.dataToDisplay[0].Probe3LastFlowTime }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Calibration:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe3CalibrationDate
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Calibration Expiry:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe3NextCalibrate
                }}</b-col>
              </b-row>
            </b-card>
            <b-card
              header="Probe 4"
              v-if="this.dataToDisplay[0].Probe4Show == 'TRUE'"
            >
              <b-row>
                <b-col class="text-left"><b>Position:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe4Position
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Tag:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe4Tag
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Temperatures:</b> </b-col>
                <b-col class="text-left"
                  ><b>Avg:</b>
                  {{ this.dataToDisplay[0].Probe4LastTempAvg }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Min:</b>
                  {{ this.dataToDisplay[0].Probe4LastTempMin }}&#8451;
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col class="text-left"
                  ><b>Max:</b>
                  {{ this.dataToDisplay[0].Probe4LastTempMax }}&#8451;</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Flow:</b> </b-col>
                <b-col class="text-left"
                  >{{ this.dataToDisplay[0].Probe4LastFlowDate }} at
                  {{ this.dataToDisplay[0].Probe4LastFlowTime }}</b-col
                >
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Last Calibration:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe4CalibrationDate
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Calibration Expiry:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].Probe4NextCalibrate
                }}</b-col>
              </b-row>
            </b-card>
            <br />
            <b-card header="Service Details">
              <b-row>
                <b-col class="text-left"><b>Last Service:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].LastServiceCheckDate
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Next Service:</b> </b-col>
                <b-col class="text-left">{{
                  this.dataToDisplay[0].NextServiceAction
                }}</b-col>
              </b-row>
              <b-row>
                <b-col class="text-left"><b>Next Service Due:</b> </b-col>
                <b-col
                  v-if="
                    this.dataToDisplay[0].NextServiceDate ==
                      'No Future Service Planned'
                  "
                  class="text-left"
                  >{{ this.dataToDisplay[0].NextServiceDate }}</b-col
                >
                <b-col
                  v-if="
                    this.dataToDisplay[0].NextServiceDate !=
                      'No Future Service Planned'
                  "
                  class="text-left"
                  >{{ this.dataToDisplay[0].NextServiceDate }} at
                  {{ this.dataToDisplay[0].NextServiceTime }}</b-col
                >
              </b-row>
              <b-row
                ><b-col><br /></b-col
              ></b-row>
            </b-card>
            <br />
            <b-card header="Linked Devices">
              <h5 v-if="this.dataToDisplay[0].LinkedAssets.length == 0">
                You don't currently have any endpoints associated with this
                device.
              </h5>
              <b-card-body>
                <b-row
                  v-for="(id, idx) in this.dataToDisplay[0].LinkedAssets"
                  :key="idx"
                >
                  <b-col class="text-left"><b>Type:</b> {{ id.Type }}</b-col>
                  <b-col class="text-left"><b>ID:</b> {{ id.ID }}</b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-body>
        </b-card>
      </div>
      <b-card
        no-body
        border-variant="dark"
        align="center"
        header-bg-variant="secondary"
        v-if="this.detailToShow == 'HW'"
      >
        <template #header
          ><h4>{{ headerText }}</h4>
        </template>
        <br />
        <b-card-body>
          <b-card-sub-title class="mb-2">
            Installation Date: {{ this.dataToDisplay[0].UnitInstallDate }}
          </b-card-sub-title>
          <b-card header="Position Details">
            <b-row>
              <b-col class="text-left"><b>Room/Area:</b> </b-col>
              <b-col class="text-left">
                {{ this.dataToDisplay[0].UnitLocation }}</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Position Note:</b> </b-col>
              <b-col class="text-left">{{
                this.dataToDisplay[0].UnitNote
              }}</b-col>
            </b-row>
            <b-row v-if="this.dataToDisplay[0].UnitGroupCount != null">
              <b-col class="text-center"
                ><h5>
                  Washbasin Unit Linked with
                  {{ this.dataToDisplay[0].UnitGroupCount }} Location Group(s)
                </h5></b-col
              >
            </b-row>
          </b-card>
          <br />
          <b-card header="Reading Details">
            <b-row>
              <b-col class="text-left"><b>Last Reading:</b> </b-col>
              <b-col class="text-left"
                >{{ this.dataToDisplay[0].UnitLastReading }} At
                {{ this.dataToDisplay[0].UnitLastReadingTime }}</b-col
              >
            </b-row>
            <b-row
              ><b-col><br /></b-col
            ></b-row>
            <b-row>
              <b-col class="text-left"><b>Last Temperatures:</b> </b-col>
              <b-col class="text-left"
                ><b>Cold:</b>{{ this.dataToDisplay[0].UnitLastCold }} &#8451;
              </b-col>
            </b-row>
            <b-row>
              <b-col></b-col>
              <b-col class="text-left"
                ><b>Hot:</b>
                {{ this.dataToDisplay[0].UnitLastHot }} &#8451;</b-col
              >
            </b-row>
            <br />
          </b-card>
          <br />
          <b-card header="Unit Data">
            <b-row>
              <b-col class="text-left"><b>Last Handwash:</b> </b-col
              ><b-col class="text-left"
                >{{ this.dataToDisplay[0].UnitLastHandwash }} At
                {{ this.dataToDisplay[0].UnitLastHandwashTime }}</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Last Mixed Flush:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitLastMixed != null"
                >{{ this.dataToDisplay[0].UnitLastMixed }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitLastMixed == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Last Thermal Flush:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitLastThermal != null"
                >{{ this.dataToDisplay[0].UnitLastThermal }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitLastThermal == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Last Chemical Flush:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitLastChemical != null"
                >{{ this.dataToDisplay[0].UnitLastChemical }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitLastChemical == null"
                >N/A</b-col
              >
            </b-row>
            <br />
            <b-row>
              <b-col class="text-left"><b>Soap Replaced:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitSoapChange != null"
                >{{ this.dataToDisplay[0].UnitSoapChange }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitSoapChange == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Alcohol Gel Replaced:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitAlcoChange != null"
                >{{ this.dataToDisplay[0].UnitAlcoChange }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitAlcoChange == null"
                >N/A</b-col
              >
            </b-row>
          </b-card>
          <br />
          <b-card header="Service Details">
            <b-row>
              <b-col class="text-left"><b>Last Service:</b> </b-col>
              <b-col class="text-left">{{
                this.dataToDisplay[0].UnitLastService
              }}</b-col>
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Next Service:</b> </b-col>
              <b-col class="text-left">{{
                this.dataToDisplay[0].UnitNextServiceDate
              }}</b-col>
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Next Service Due:</b> </b-col>
              <b-col
                v-if="this.dataToDisplay[0].UnitNextServiceDate == null"
                class="text-left"
                >N/A</b-col
              >
              <b-col
                v-if="this.dataToDisplay[0].UnitNextServiceDate != null"
                class="text-left"
                >{{ this.dataToDisplay[0].UnitNextServiceDate }} at
                {{ this.dataToDisplay[0].NextServiceTime }}</b-col
              >
            </b-row>
            <br />
          </b-card>
          <b-card header="Testing Detail">
            <b-row>
              <b-col class="text-left"><b>Last Water Test:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitLastWaterTest != null"
                >{{ this.dataToDisplay[0].UnitLastWaterTest }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitLastWaterTest == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Last Test Result:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitLastResult != null"
                >{{ this.dataToDisplay[0].UnitLastResult }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitLastResult == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Next Test Scheduled:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitNextTest != null"
                >{{ this.dataToDisplay[0].UnitNextTest }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].UnitNextTest == null"
                >No Test Scheduled</b-col
              >
            </b-row>
          </b-card>
          <br />
        </b-card-body>
      </b-card>
      <b-card
        no-body
        border-variant="dark"
        align="center"
        header-bg-variant="secondary"
        v-if="this.detailToShow == 'Outlet'"
      >
        <template #header
          ><h4>{{ headerText }}</h4>
        </template>
        <br />
        <b-card-body>
          <b-card-sub-title class="mb-2"
            >Location: {{ this.dataToDisplay[0].OutletDept }}</b-card-sub-title
          >
          <b-card header="Position Details">
            <b-row>
              <b-col class="text-left"><b>Outlet Type:</b> </b-col>
              <b-col class="text-left">{{
                this.dataToDisplay[0].OutletType
              }}</b-col>
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Room/Area:</b> </b-col>
              <b-col class="text-left">
                {{ this.dataToDisplay[0].OutletDept }}</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Position Note:</b> </b-col>
              <b-col class="text-left">{{
                this.dataToDisplay[0].OutletLocNote
              }}</b-col>
            </b-row>
            <br />
            <b-row>
              <b-col
                class="text-center"
                v-if="this.dataToDisplay[0].OutletSentinel == 'TRUE'"
                ><h4>This is a Sentinel Outlet</h4></b-col
              >
            </b-row>
          </b-card>
          <br />
          <b-card header="Filter Details">
            <b-row>
              <b-col class="text-left"><b>Filter Type:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletFilter != null"
                >{{ this.dataToDisplay[0].OutletFilter }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletFilter == null"
                >No Filter Fitted</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Filter Last Changed:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletFilterFitted != null"
              >
                {{ this.dataToDisplay[0].OutletFilterFitted }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletFilterFitted == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Filter Expiry:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletFilterExpiry != null"
                >{{ this.dataToDisplay[0].OutletFilterExpiry }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletFilterExpiry == null"
                >N/A</b-col
              >
            </b-row>
          </b-card>
          <br />
          <b-card
            header="Shower Accessory Details"
            v-if="this.dataToDisplay[0].OutletType == 'Shower'"
          >
            <b-row>
              <b-col class="text-left"><b>Shower Pack Fitted:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletShowerType != null"
                >{{ this.dataToDisplay[0].OutletShowerType }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletShowerType == null"
                >No Pack Fitted</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Pack Last Changed:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletShowerFitted != null"
              >
                {{ this.dataToDisplay[0].OutletShowerFitted }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletShowerFitted == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Pack Expiry:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletShowerExpiry != null"
                >{{ this.dataToDisplay[0].OutletShowerExpiry }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletShowerExpiry == null"
                >N/A</b-col
              >
            </b-row>
          </b-card>
          <br />
          <b-card header="Testing Detail">
            <b-row>
              <b-col class="text-left"><b>Last Water Test:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletTestDate != null"
                >{{ this.dataToDisplay[0].OutletTestDate }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletTestDate == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Last Test Type:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletTestType != null"
                >{{ this.dataToDisplay[0].OutletTestType }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletTestType == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Last Test Result:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletTestResult != null"
                >{{ this.dataToDisplay[0].OutletTestResult }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletTestResult == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Next Scheduled:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletTestNext != null"
                >{{ this.dataToDisplay[0].OutletTestNext }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletTestNext == null"
                >No upcoming tests</b-col
              >
            </b-row>
          </b-card>
          <br />
          <b-card header="Risk Assessment Detail">
            <b-row>
              <b-col class="text-left"><b>Last Risk Assessment:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletAssess != null"
                >{{ this.dataToDisplay[0].OutletAssess }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletAssess == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Last Assesment ID:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletAssessID != null"
                >{{ this.dataToDisplay[0].OutletAssessID }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletAssessID == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Next Scheduled:</b> </b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletAssessDate != null"
                >{{ this.dataToDisplay[0].OutletAssessDate }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletAssessDate == null"
                >N/A</b-col
              >
            </b-row>
          </b-card>
          <br />
          <b-card header="Manual Temperature Testing">
            <b-row>
              <b-col class="text-left"><b>Last Manual Check:</b></b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletManTempDate != null"
                >{{ this.dataToDisplay[0].OutletManTempDate }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletManTempDate == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Hot Temp:</b></b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletManTempHot != null"
                >{{ this.dataToDisplay[0].OutletManTempHot }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletManTempHot == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Cold Temp:</b></b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletManTempCold != null"
                >{{ this.dataToDisplay[0].OutletManTempCold }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletManTempCold == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Mixed Temp:</b></b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletManTempMix != null"
                >{{ this.dataToDisplay[0].OutletManTempMix }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletManTempMix == null"
                >N/A</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-left"><b>Return Temp:</b></b-col>
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletManTempReturn != null"
                >{{ this.dataToDisplay[0].OutletManTempReturn }}</b-col
              >
              <b-col
                class="text-left"
                v-if="this.dataToDisplay[0].OutletManTempReturn == null"
                >N/A</b-col
              >
            </b-row>
          </b-card>
          <br />
          <b-card header="Linked Devices">
            <h5 v-if="this.dataToDisplay[0].LinkedAssets.length == 0">
              You don't currently have any devices associated with this outlet.
            </h5>
            <b-card-body>
              <b-row
                v-for="(id, idx) in this.dataToDisplay[0].LinkedAssets"
                :key="idx"
              >
                <b-col class="text-left"><b>Type:</b> {{ id.Type }}</b-col>
                <b-col class="text-left"><b>ID:</b> {{ id.ID }}</b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  computed: {},
  components: {},

  data() {
    return {
      detailToShow: this.$DetailToShow,
      headerText: "",
      dataToDisplay: [],
      loading: true,
      HumanName: this.$HumanName
    };
  },

  mounted() {
    if (this.detailToShow == "C-1" || this.detailToShow == "O-1") {
      this.headerText = "" + this.detailToShow + " Device: " + this.$HumanName;
    }

    if (this.detailToShow == "Outlet") {
      this.headerText = this.detailToShow + ": " + this.$DeviceID;
      this.loading = false;
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersFeed = this.$apikeyPost;
      this.LookUpRequest = {
        RequestVariable: this.$DeviceID,
        Report: "OutletDetail",
        RequestType: "",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
        .then((response) => {

          let OutletData = response.data.Values;

          let LinkedOutletEndpointsArray = OutletData[0][17];

          let LinkedOutletEndpointsData = [];

          for (let u = 0; u < LinkedOutletEndpointsArray.length; u++) {
            LinkedOutletEndpointsData.push({
              ID: LinkedOutletEndpointsArray[u][0],
              Type: LinkedOutletEndpointsArray[u][1],
            });
          }

          this.dataToDisplay.push({
            OutletID: OutletData[0][0],
            OutletType: OutletData[0][1],
            OutletFeed: OutletData[0][2],
            OutletPos: OutletData[0][3],
            OutletDept: OutletData[0][4],
            OutletLocNote: OutletData[0][5],
            OutletSentinel: OutletData[0][6],
            OutletFilter: OutletData[0][7],
            OutletFilterFitted: OutletData[0][8],
            OutletFilterExpiry: OutletData[0][9],
            OutletAssess: OutletData[0][14],
            OutletAssessID: OutletData[0][15],
            OutletAssessDate: OutletData[0][16],
            OutletTestDate: OutletData[0][10],
            OutletTestType: OutletData[0][11],
            OutletTestResult: OutletData[0][12],
            OutletTestNext: OutletData[0][13],
            LinkedAssets: LinkedOutletEndpointsData,
            OutletShowerType: OutletData[0][18],
            OutletShowerFitted: OutletData[0][19],
            OutletShowerExpiry: OutletData[0][20],
            OutletManTempDate: OutletData[0][21],
            OutletManTempTime: OutletData[0][22],
            OutletManTempHot: OutletData[0][23],
            OutletManTempCold: OutletData[0][24],
            OutletManTempMix: OutletData[0][25],
            OutletManTempReturn: OutletData[0][26],
          });
        });
      this.loading = false;
    }

    if (this.detailToShow == "HW") {
      this.headerText = "Washbasin Unit: " + this.$DeviceID;

      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersWB = this.$apikeyPost;
      this.LookUpRequest = {
        RequestVariable: this.$DeviceID,
        Report: "WashbasinDetail",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeadersWB)
        .then((response) => {
          let WashbasinData = response.data.Values;

          this.dataToDisplay.push({
            UnitID: WashbasinData[0][0],
            UnitInstallDate: WashbasinData[0][1],
            UnitLocation: WashbasinData[0][2],
            UnitNote: WashbasinData[0][3],
            UnitGroupCount: WashbasinData[0][4],
            UnitLastReading: WashbasinData[0][5],
            UnitLastReadingTime: WashbasinData[0][6],
            UnitLastHot: WashbasinData[0][7],
            UnitLastCold: WashbasinData[0][8],
            UnitLastHandwash: WashbasinData[0][9],
            UnitLastHandwashTime: WashbasinData[0][10],
            UnitLastMixed: WashbasinData[0][11],
            UnitLastThermal: WashbasinData[0][12],
            UnitLastChemical: WashbasinData[0][13],
            UnitSoapChange: WashbasinData[0][14],
            UnitAlcoChange: WashbasinData[0][15],
            UnitLastService: WashbasinData[0][16],
            UnitNextServiceDate: WashbasinData[0][17],
            UnitNextServiceNote: WashbasinData[0][18],
            UnitLastWaterTest: WashbasinData[0][19],
            UnitLastResult: WashbasinData[0][20],
            UnitNextTest: WashbasinData[0][21],
          });
        });

      this.loading = false;
    }

    if (this.detailToShow == "Subgroup") {
      this.headerText = "Location Group: " + this.$DeviceID;

      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersFeed = this.$apikeyPost;
      this.LookUpRequest = {
        RequestVariable: this.$DeviceID,
        Report: "GroupDetail",
        RequestType: "",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
        .then((response) => {
          let deviceData = response.data;
          let deviceTrends = deviceData.GroupTrendCounts;
          let deviceLevels = deviceData.GroupLevels;
          let deviceWaterTests = deviceData.WaterTestCounts;
          let deviceAccessories = deviceData.Accessories;
          let deviceRiskAssessments = deviceData.RiskAssessments;
          let deviceActions = deviceData.RemedialActions;

          this.dataToDisplay.push({
            Level1: deviceLevels.Level1,
            Level2: deviceLevels.Level2,
            Level3: deviceLevels.Level3,
            StableCount: deviceTrends.StableTrendCount,
            TrendingUpCount: deviceTrends.UpTrendCount,
            TrendingDownCount: deviceTrends.DownTrendCount,
            NewTests: deviceWaterTests.NewWaterTests,
            ProgressTests: deviceWaterTests.TestsInProgress,
            ReviewTests: deviceWaterTests.TestsUnderReview,
            CompletedTests: deviceWaterTests.CompletedTests,
            ScheduledTests: deviceWaterTests.ScheduledTests,
            ShowerDue: deviceAccessories.ShowerAccessoriesDue,
            ShowerOverDue: deviceAccessories.ShowerAccessoriesOverdue,
            FiltersDue: deviceAccessories.FiltersDue,
            FiltersOverDue: deviceAccessories.FiltersOverdue,
            RiskAssessmentDue: deviceRiskAssessments.DueAssessments,
            RiskAssessmentValid: deviceRiskAssessments.ValidAssessments,
            RiskAssessmentExpired: deviceRiskAssessments.ExpiredAssessments,
            RiskAssessmentCompleted: deviceRiskAssessments.CompletedPast28Days,
            ActionsDue: deviceActions.Due,
            ActionsNew: deviceActions.New,
            ActionsOverdue: deviceActions.Overdue,
            ActionsCompleted: deviceActions.CompletedPast28Days,
          });
        });
      this.loading = false;
    }

    if (this.detailToShow == "C-1") {
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersFeed = this.$apikeyPost;
      this.LookUpRequest = {
        RequestVariable: this.$DeviceID,
        Report: "C1DeviceDetail",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
        .then((response) => {
          console.log(response)
          let deviceData = response.data.Values;
          console.log(deviceData)      

          let LinkedAssetsEndpointsArray = deviceData[0][19];
          let LinkedAssetsEndpointsData = [];

            if(LinkedAssetsEndpointsArray.length > 0){
            for (let u = 0; u < LinkedAssetsEndpointsArray.length; u++) {
              LinkedAssetsEndpointsData.push({
                ID: LinkedAssetsEndpointsArray[u][0],
                Type: LinkedAssetsEndpointsArray[u][1],
              });
            }
          } else{
            LinkedAssetsEndpointsData = []
          }
            let Pipe1Calibration = "";
            let Pipe2Calibration = "";
            let NextPipe1Calibration = "";
            let NextPipe2Calibration = "";

             if (deviceData[0][12] == null) {
              Pipe1Calibration = "No Previous Calibration";
              NextPipe1Calibration = "N/A";
            } else {
              Pipe1Calibration = deviceData[0][12];

              NextPipe1Calibration = new Date(Pipe1Calibration);
              let thisYear = NextPipe1Calibration.getFullYear();
              let nextYear = thisYear + 1;

              NextPipe1Calibration.setYear(nextYear);
              NextPipe1Calibration = NextPipe1Calibration.toISOString().slice(
                0,
                10
              );
            }
            if (deviceData[0][17] == null) {
              Pipe2Calibration = "No Previous Calibration";
              NextPipe2Calibration = "N/A";
            } else {
              Pipe2Calibration = deviceData[0][17];
              NextPipe2Calibration = new Date(Pipe2Calibration);
              let thisYear = NextPipe2Calibration.getFullYear();
              let nextYear = thisYear + 1;

              NextPipe2Calibration.setYear(nextYear);
              NextPipe2Calibration = NextPipe2Calibration.toISOString().slice(
                0,
                10
              );
            }

            let LastServiceInfo = "";
            let NextServiceDue = "";

             if (deviceData[0][7] == null) {
              LastServiceInfo = "No Previous Service";
            } else {
              LastServiceInfo = deviceData[0][7];
            }

            if (
              deviceData[0][4] == null ||
              deviceData[0][5] == null ||
              deviceData[0][6] == null
            ) {
              NextServiceDue = "No Future Service Planned";
            } else {
              NextServiceDue = deviceData[0][4];
            }


          let probe1tag = 'No Tag';
          let probe2tag = 'No Tag';

          let probeArray = deviceData[3];

          for(let x=0;x<probeArray.length;x++){ 
            if (probeArray[x].length > 0){
              if(probeArray[x][0] == '1'){
                probe1tag = probeArray[x][1]
              } else if(probeArray[x][0] == '2'){
                probe2tag = probeArray[x][1]
            } else{
               probe1tag = 'No Tag';
               probe2tag = 'No Tag';
            }
          }
        }


           this.dataToDisplay.push({
              id: deviceData[0][0],
              Location: deviceData[0][1],
              DeptFloor: deviceData[0][2],
              LocationNote: deviceData[0][3],
              CurrentTrend: "None",
              NextServiceDate: NextServiceDue,
              NextServiceTime: deviceData[0][5],
              NextServiceAction: deviceData[0][6],
              LastServiceCheckDate: LastServiceInfo,
              Probe1Show: deviceData[0][8],
              Probe2Show: deviceData[0][13],
              Probe1Feed: deviceData[0][9],
              Probe1Position: deviceData[0][10],
              Probe1LastTempMin: deviceData[0][11],
              Probe1CalibrationDate: Pipe1Calibration,
              Probe1NextCalibrate: NextPipe1Calibration,
              Probe1LastTempMax: deviceData[0][24],
              Probe1LastTempAvg: deviceData[0][25],
              Probe1Tag: probe1tag,

              Probe1LastFlowDate: this.AddTimeZone(
                deviceData[0][28],
                deviceData[0][29]
              ).Date,
              Probe1LastFlowTime: this.AddTimeZone(
                deviceData[0][28],
                deviceData[0][29]
              ).Time,

              Probe2Feed: deviceData[0][14],
              Probe2Position: deviceData[0][15],
              Probe2LastTempMin: deviceData[0][16],
              Probe2CalibrationDate: Pipe2Calibration,
              Probe2NextCalibrate: NextPipe2Calibration,
              Probe2LastTempMax: deviceData[0][26],
              Probe2LastTempAvg: deviceData[0][27],
              Probe2Tag: probe2tag,

              Probe2LastFlowDate: this.AddTimeZone(
                deviceData[0][30],
                deviceData[0][31]
              ).Date,
              Probe2LastFlowTime: this.AddTimeZone(
                deviceData[0][30],
                deviceData[0][31]
              ).Time,
              InstallDate: deviceData[0][18],
              InstallTime: deviceData[0][20],
              LastTempReadingDate: this.AddTimeZone(
                deviceData[0][21],
                deviceData[0][22]
              ).Date,
              LastTempReadingTime: this.AddTimeZone(
                deviceData[0][21],
                deviceData[0][22]
              ).Time,
              LinkedAssets: LinkedAssetsEndpointsData,
              SubGroupCount: deviceData[0][23],
            });
          this.loading = false;
        });
    } else if (this.detailToShow == "O-1") {
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersFeed = this.$apikeyPost;
      this.LookUpRequest = {
        RequestVariable: this.$DeviceID,
        Report: "O1DeviceDetail",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
        .then((response) => {
          let deviceData = response.data.Values;

          for (let i = 0; i < deviceData.length; i++) {
            let LinkedAssetsEndpointsArray = deviceData[i][33];
            let LinkedAssetsEndpointsData = [];

            for (let u = 0; u < LinkedAssetsEndpointsArray.length; u++) {
              LinkedAssetsEndpointsData.push({
                ID: LinkedAssetsEndpointsArray[u][0],
                Type: LinkedAssetsEndpointsArray[u][1],
              });
            }

            let Pipe1Calibration = "";
            let Pipe2Calibration = "";
            let Pipe3Calibration = "";
            let Pipe4Calibration = "";
            let NextPipe1Calibration = "";
            let NextPipe2Calibration = "";
            let NextPipe3Calibration = "";
            let NextPipe4Calibration = "";

            let LastServiceInfo = "";
            let NextServiceDue = "";
            // let LinkedAssetsInfo = "";

            if (deviceData[i][13] == null) {
              Pipe1Calibration = "No Previous Calibration";
              NextPipe1Calibration = "N/A";
            } else {
              Pipe1Calibration = deviceData[i][13];

              NextPipe1Calibration = new Date(Pipe1Calibration);
              let thisYear = NextPipe1Calibration.getFullYear();
              let nextYear = thisYear + 1;

              NextPipe1Calibration.setYear(nextYear);
              NextPipe1Calibration = NextPipe1Calibration.toISOString().slice(
                0,
                10
              );
            }
            if (deviceData[i][18] == null) {
              Pipe2Calibration = "No Previous Calibration";
              NextPipe2Calibration = "N/A";
            } else {
              Pipe2Calibration = deviceData[i][18];
              NextPipe2Calibration = new Date(Pipe2Calibration);
              let thisYear = NextPipe2Calibration.getFullYear();
              let nextYear = thisYear + 1;

              NextPipe2Calibration.setYear(nextYear);
              NextPipe2Calibration = NextPipe2Calibration.toISOString().slice(
                0,
                10
              );
            }
            if (deviceData[i][23] == null) {
              Pipe3Calibration = "No Previous Calibration";
              NextPipe3Calibration = "N/A";
            } else {
              Pipe3Calibration = deviceData[i][23];
              NextPipe3Calibration = new Date(Pipe3Calibration);
              let thisYear = NextPipe3Calibration.getFullYear();
              let nextYear = thisYear + 1;

              NextPipe3Calibration.setYear(nextYear);
              NextPipe3Calibration = NextPipe3Calibration.toISOString().slice(
                0,
                10
              );
            }
            if (deviceData[i][28] == null) {
              Pipe4Calibration = "No Previous Calibration";
              NextPipe4Calibration = "N/A";
            } else {
              Pipe4Calibration = deviceData[i][28];
              NextPipe4Calibration = new Date(Pipe4Calibration);
              let thisYear = NextPipe4Calibration.getFullYear();
              let nextYear = thisYear + 1;

              NextPipe4Calibration.setYear(nextYear);
              NextPipe4Calibration = NextPipe4Calibration.toISOString().slice(
                0,
                10
              );
            }

            if (deviceData[i][8] == null) {
              LastServiceInfo = "No Previous Service";
            } else {
              LastServiceInfo = deviceData[i][8];
            }

            if (
              deviceData[i][5] == null ||
              deviceData[i][6] == null ||
              deviceData[i][7] == null
            ) {
              NextServiceDue = "No Future Service Planned";
            } else {
              NextServiceDue = deviceData[i][5];
            }

          let probe1tag = 'No Tag';
          let probe2tag = 'No Tag';
          let probe3tag = 'No Tag';
          let probe4tag = 'No Tag';

          let probeArray = deviceData[i][34];

          for(let x=0;x<probeArray.length;x++){ 
            if (probeArray[x].length > 0){
              if(probeArray[x][0] == '1'){
                probe1tag = probeArray[x][1]
              } else if(probeArray[x][0] == '2'){
                probe2tag = probeArray[x][1]
              } else if(probeArray[x][0] == '3'){
                probe3tag = probeArray[x][1]
              } else if(probeArray[x][0] == '4'){
                probe4tag = probeArray[x][1]
              }
            } else{
               probe1tag = 'No Tag';
               probe2tag = 'No Tag';
               probe3tag = 'No Tag';
               probe4tag = 'No Tag';
            }
          }


            this.dataToDisplay.push({
              id: deviceData[i][0],
              Location: deviceData[i][1],
              DeptFloor: deviceData[i][2],
              LocationNote: deviceData[i][3],
              CurrentTrend: deviceData[i][4],
              NextServiceDate: NextServiceDue,
              NextServiceTime: deviceData[i][6],
              NextServiceAction: deviceData[i][7],
              LastServiceCheckDate: LastServiceInfo,
              Probe1Show: deviceData[i][9],
              Probe2Show: deviceData[i][14],
              Probe3Show: deviceData[i][19],
              Probe4Show: deviceData[i][24],
              Probe1Feed: deviceData[i][10],
              Probe1Position: deviceData[i][11],
              Probe1LastTempMin: deviceData[i][12],
              Probe1CalibrationDate: Pipe1Calibration,
              Probe1NextCalibrate: NextPipe1Calibration,
              Probe1LastTempMax: deviceData[i][35],
              Probe1LastTempAvg: deviceData[i][36],
              Probe1Tag: probe1tag,

              Probe1LastFlowDate: this.AddTimeZone(
                deviceData[i][44],
                deviceData[i][45]
              ).Date,
              Probe1LastFlowTime: this.AddTimeZone(
                deviceData[i][44],
                deviceData[i][45]
              ).Time,

              Probe2Feed: deviceData[i][15],
              Probe2Position: deviceData[i][16],
              Probe2LastTempMin: deviceData[i][17],
              Probe2CalibrationDate: Pipe2Calibration,
              Probe2NextCalibrate: NextPipe2Calibration,
              Probe2LastTempMax: deviceData[i][37],

              Probe2LastTempAvg: deviceData[i][38],
              Probe2Tag: probe2tag,

              Probe2LastFlowDate: this.AddTimeZone(
                deviceData[i][46],
                deviceData[i][47]
              ).Date,
              Probe2LastFlowTime: this.AddTimeZone(
                deviceData[i][46],
                deviceData[i][47]
              ).Time,

              Probe3Feed: deviceData[i][20],
              Probe3Position: deviceData[i][21],
              Probe3LastTempMin: deviceData[i][22],
              Probe3CalibrationDate: Pipe3Calibration,
              Probe3NextCalibrate: NextPipe3Calibration,
              Probe3LastTempMax: deviceData[i][39],

              Probe3LastTempAvg: deviceData[i][40],
              Probe3Tag: probe3tag,

              Probe3LastFlowDate: this.AddTimeZone(
                deviceData[i][48],
                deviceData[i][49]
              ).Date,
              Probe3LastFlowTime: this.AddTimeZone(
                deviceData[i][48],
                deviceData[i][49]
              ).Time,

              Probe4Feed: deviceData[i][25],
              Probe4Position: deviceData[i][26],
              Probe4LastTempMin: deviceData[i][27],
              Probe4CalibrationDate: Pipe4Calibration,
              Probe4NextCalibrate: NextPipe4Calibration,
              Probe4LastTempMax: deviceData[i][41],

              Probe4LastTempAvg: deviceData[i][42],
              Probe4Tag: probe4tag,

              Probe4LastFlowDate: this.AddTimeZone(
                deviceData[i][50],
                deviceData[i][51]
              ).Date,
              Probe4LastFlowTime: this.AddTimeZone(
                deviceData[i][50],
                deviceData[i][51]
              ).Time,
              InstallDate: deviceData[i][29],
              InstallTime: deviceData[i][30],
              LastTempReadingDate: this.AddTimeZone(
                deviceData[i][31],
                deviceData[i][32]
              ).Date,
              LastTempReadingTime: this.AddTimeZone(
                deviceData[i][31],
                deviceData[i][32]
              ).Time,
              LinkedAssets: LinkedAssetsEndpointsData,
              SubGroupCount: deviceData[i][35],
            });
          }
          this.loading = false;
        });
    }
  },
  methods: {
    AddTimeZone(DateValue, Time) {
      if (Date == null || Time == null) {
        return {
          Date: null,
          Time: null,
        };
      }

      let TimeDateObject = DateValue + ", " + Time;


      const dt = new Date();
      let diffTZ = dt.getTimezoneOffset();
      let newDate = new Date(TimeDateObject);


      let timeinseconds = Math.floor(new Date(newDate).getTime() / 1000);


      let timezoneoffsetseconds = diffTZ * 60;

      let offsetTimeSecs = timeinseconds - timezoneoffsetseconds;


      let offsetDate = new Date(offsetTimeSecs * 1000);

      const nlBEFormatter = new Intl.DateTimeFormat("nl-BE");
      let offsetDateString = offsetDate.toString();
      let position = offsetDateString.search(/:/);

      let offsetTime = offsetDateString.slice(position - 2, position + 6);

      let offsetDateObject = {
        Date: nlBEFormatter.format(offsetDate),
        Time: offsetTime,
      };

      return offsetDateObject;
    },

    logout() {
      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });
      /*  let UserName=this.profile.name; */
      let UserPortal = this.$ProfilePortal;
      let UserURN = this.$UserURN;

      let EventHistory = "Logged Out";

      axios.get("https://www.cloudflare.com/cdn-cgi/trace").then((response) => {
        this.response = response.data;
        let UserIPAddress = this.response.substring(
          this.response.search("ip=") + 3,
          this.response.search("ts=") - 1
        );
        let sendUrl =
          "https://bg4rfm4uqd.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/userhistory";

        let sendData = {
          UserURN: UserURN,
          UserIPAddress: UserIPAddress,
          HistoryDate: HistoryDate,
          HistoryTime: HistoryTime,
          HistoryNote: EventHistory,
          ProfilePortal: UserPortal,
        };
        let sendHeaders = this.$apikeyPost;
        axios
          .post(sendUrl, sendData, sendHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => "error: " + err);
      });

      this.$auth.logout();
    },
  },
};
</script>

<style>
.accessDeniedDiv {
  background-color: red;
}
.accessDenied {
  color: white;
  margin-top: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
h1 {
  color: white;
}
.returnLink {
  text-align: left;
  text-decoration: underline;
  font-weight: 500;
  position: absolute;
  margin-top: 2.5%;
  padding-left: 1rem;
  margin-left: -15px;
}
</style>
